import { render, staticRenderFns } from "./customerSelect.vue?vue&type=template&id=10fef79a&scoped=true"
import script from "./customerSelect.vue?vue&type=script&lang=js"
export * from "./customerSelect.vue?vue&type=script&lang=js"
import style0 from "./customerSelect.vue?vue&type=style&index=0&id=10fef79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fef79a",
  null
  
)

export default component.exports